// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1zS1f","empty":"ModalGraph_empty__3cvwK"};